import { PaginationRequest } from '@repo/ui/data-table'

import { TripBookingDispatchPlacePartial } from '../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type AffectedStaffDispatchPlacesFilter = {
  dispatched?: boolean
}

export function getAffectStaffDispatchPlaces(
  id: number,
  input: PaginationRequest<AffectedStaffDispatchPlacesFilter>
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.affectedStaffs.getAffectStaffDispatchPlaces.url, { id }),
        input
      )
    )
    .get<TripBookingDispatchPlacePartial[]>()
}
